import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';
import type { FilterHistory } from '../@types/FilterHistory';
import type { SearchHistory } from '../@types/SearchHistory';
import type { BaseAction } from '../@types/actions';
import QueryFilter from '../helpers/query-filter';
import type { RootState } from '../reducers';

export const REQ_SEARCH_HISTORY = 'REQ/SEARCH_HISTORY';
export type REQ_SEARCH_HISTORY_TYPE = BaseAction<typeof REQ_SEARCH_HISTORY> & {
  history: SearchHistory[];
};

export type HISTORY_ACTION = REQ_SEARCH_HISTORY_TYPE;

type Dispatch = ReduxDispatch<HISTORY_ACTION>;

const merge = (list: FilterHistory[]): SearchHistory[] => {
  const cache: { [key: string]: boolean } = {};

  return list
    .map((hit) => ({
      query: QueryFilter.create(hit.query)
        .removeAll(['page', 'offset', 'size', 'hits', 'sort'])
        .toString(),
      count: hit.count,
      createdAt: hit.createdAt,
    }))
    .filter((hit) => {
      if (cache[hit.query]) {
        return false;
      }

      cache[hit.query] = true;
      return true;
    });
};

const localStorageKey = 'wayke-filter-history';
export const history =
  (queryFilter?: QueryFilter) => (dispatch: Dispatch, getState: () => RootState) => {
    try {
      const cleanQueryFilter =
        queryFilter && queryFilter.removeAll(['page', 'offset', 'size', 'hits', 'sort']);

      const { search } = getState();
      const query =
        cleanQueryFilter && !cleanQueryFilter.isEmpty() ? cleanQueryFilter.toString() : false;
      const persistance = merge(
        JSON.parse(localStorage.getItem(localStorageKey) || '[]') as FilterHistory[],
      );
      const index = persistance.findIndex((hit) => hit.query === query);

      if (search.documentList) {
        if (query && index < 0) {
          persistance.unshift({
            query,
            count: search.documentList.numberOfHits,
            createdAt: new Date().getTime(),
          });

          localStorage.setItem(localStorageKey, JSON.stringify(persistance.slice(0, 50)));
        } else if (
          query &&
          index >= 0 &&
          persistance[index].count !== search.documentList.numberOfHits
        ) {
          persistance[index] = {
            query,
            count: search.documentList.numberOfHits,
            createdAt: new Date().getTime(),
          };

          localStorage.setItem(localStorageKey, JSON.stringify(persistance.slice(0, 50)));
        }
      }
      dispatch({ type: REQ_SEARCH_HISTORY, history: persistance });
    } catch (_e) {
      dispatch({ type: REQ_SEARCH_HISTORY, history: [] });
    }
  };
